import { makeAutoObservable } from 'mobx';
import FirebaseStore from './firebaseStore';
import { UserStore } from './userStore'
import {
  requestBankInfo,
  getRequestedPayouts,
  getUserProfile,
  updatePaymentStatusToPaid,
  getRequestedTransactions,
  findAssociatedRefundTransaction,
  refundTransaction,
  createPayout,
  getUsers,
  flagUser,
  unFlagUser,
  getMigrationStatus,
  startMigrationRun
} from '../utils/apiClients';
import { TransactionStatus, TrxLogType } from 'realhaus-sdk'

export class DashboardStore {
  constructor(private firestore: FirebaseStore, private userStore: UserStore) {
    makeAutoObservable(this);
  }

  getMigrationStatus = async () => {
    if (!this.userStore.isAuthenticated) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || '';
    return await getMigrationStatus(token);
  }

  startMigrationRun = async () => {
    if (!this.userStore.isAuthenticated) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || '';
    return await startMigrationRun(token);
  }

  fetchUsers = async (cursor?: string) => {
    if (!this.userStore.isAuthenticated) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || '';
    return await getUsers(token, cursor);
  }

  createUserPayout = async (uid: string) => {
    if (!this.userStore.isAuthenticated) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || '';
    return await createPayout(token, uid);
  }

  flagUser = async (uid: string, userIsFlagged: boolean) => {
    if (!this.userStore.isAuthenticated) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || '';
    return await (userIsFlagged ? unFlagUser(token, uid) : flagUser(token, uid));
  }

  getPayouts = async (cursor?: { id: string, timestamp: number }) => {
    if (!this.userStore.isAuthenticated) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || ''
    return await getRequestedPayouts(token, cursor);
  }

  getTransactionLogs = async (cursor?: { id: string, timestamp: number }, trxLogId?: string, statuses?: TransactionStatus[], types?: TrxLogType[]) => {
    if (!this.userStore.isAuthenticated) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || ''
    return await getRequestedTransactions(token, cursor, trxLogId, statuses, types);
  }

  findPaymentRefundTransaction = async (trxLogId: string) => {
    if (!this.userStore.isAuthenticated) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || ''
    return await findAssociatedRefundTransaction(token, trxLogId);
  }

  refundTransaction = async (trxLogId: string) => {
    if (!this.userStore.isAuthenticated) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || ''
    return await refundTransaction(token, trxLogId);
  }

  getUserProfile = async (userId: string) => {
    if (!this.userStore.isAuthenticated) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || ''
    return await getUserProfile(token, userId)
  }

  getBankAccountInfos = async (userId: string) => {
    if (!this.userStore.isAuthenticated) return;

    if (!userId) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || ''
    return await requestBankInfo(token, userId);
  }

  changeStatusToPaid = async (trxLogId: string) => {
    const uid = this.userStore?.userId

    if (!uid) return;

    const token = await this.firestore.authService.currentUser?.getIdToken() || ''
    return await updatePaymentStatusToPaid(token, trxLogId);
  }
}